import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import NewAgenda from "./NewAgenda/NewAgenda";

import data2019 from "./2019.json";
import data2020 from "./2020.json";
import data2021 from "./2021.json";
import data2022 from "./2022.json";
import data2023 from "./2023.json";
import data2024 from "./2024.json";
import data2025 from "./2025.json";
import data2026 from "./2026.json";
import AgendaFilter from "./agendaFilter";

const scheduleDataByYear = {
  "2019": data2019,
  "2020": data2020,
  "2021": data2021,
  "2022": data2022,
  "2023": data2023,
  "2024": data2024,
  "2025": data2025,
  "2026": data2026,
};

const latestYear = Math.max(...Object.keys(scheduleDataByYear).map(Number));
const nextProgramYear = String(latestYear + 1);

const AgendaContainer = () => {
  const [scheduleData, setScheduleData] = useState();
  const [redirect, setRedirect] = useState();
  const [nextYear, setNextYear] = useState();
  const navigate = useNavigate();
  let { yearparam } = useParams();

  const [room, setRoom] = useState();
  const [time, setTime] = useState();
  const [category, setCategory] = useState();


  useEffect(() => {
    const selectedSchedule = scheduleDataByYear[yearparam];

    setRedirect(false);
    setNextYear(false);
    setScheduleData(undefined);

    if (selectedSchedule) {
      setScheduleData(selectedSchedule);
      return;
    }

    if (yearparam === nextProgramYear) {
      setNextYear(true);
      return;
    }

    setRedirect(true);
  }, [yearparam]);

  if (redirect) {
    return navigate("/404");
  }

  if (nextYear) {
    return (
      <>
        <h2>Litt tidlig ute? <br /> Programmet for {nextProgramYear} kommer så snart det er snekret sammen 🔨</h2>
        <p>Du kan se tidligere program i vårt <a href="/arkiv">arkiv</a>.</p>
      </>
    );
  }

  if (!scheduleData) {
    return null;
  }

  const filteredEvents = scheduleData.events.filter((event) => {
    return (!room || event.trackId === room) &&
           (!time || event.slotId === time) &&
           (!category || event.type === category);
  });

  const filteredSlots = scheduleData.slots.filter((slot) => {
    return filteredEvents.some((event) => event.slotId === slot.id);
  });

  const { year, showTeamsLinks, tracks } = scheduleData;
  

  return (
    <>
      <AgendaFilter 
        scheduleData={scheduleData} 
        room={room}
        setRoom={setRoom} 
        time={time}
        setTime={setTime} 
        category={category}
        setCategory={setCategory} 
      />

      <NewAgenda
        year={year}
        tracks={tracks}
        timeslots={filteredSlots}
        events={filteredEvents}
        showTeamsLinks={showTeamsLinks}
      />
    </>
  );
};

export default AgendaContainer;
